import { useState } from "react";
import { Play, X, Camera, Sword } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const galleryItems = [
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_fencing-kids-pass/artifacts/4ljvq5sw_40128070_2377551575588273_3749921978903953408_n.jpg",
    title: "Young Fencer in Action",
  },
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_fencing-kids-pass/artifacts/ijlhh2l2_338492_10150721397297995_1691977766_o%20%281%29.jpg",
    title: "Focused & Ready",
  },
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_fencing-kids-pass/artifacts/8asf6bdh_27021786_2014567931886641_4564898827470105847_o.jpg",
    title: "Learning the Basics",
  },
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_fencing-kids-pass/artifacts/v93swhot_62002015_2985750024768422_5177392937125806080_o.jpg",
    title: "Competition Day",
  },
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_fencing-kids-pass/artifacts/lxvxe1bu_216521445_337708781176406_8709940675303153165_n.jpg",
    title: "Making New Friends",
  },
  {
    type: "image",
    src: `${BACKEND_URL}/api/convert-heic/34lem2rv_20250801_152825728_iOS.heic`,
    title: "Holiday Camp Fun",
  },
  {
    type: "image",
    src: `${BACKEND_URL}/api/convert-heic/t8k8v06q_20250805_094215163_iOS.heic`,
    title: "Training Together",
  },
  {
    type: "image",
    src: `${BACKEND_URL}/api/convert-heic/b41t5i1j_20250805_101351007_iOS.heic`,
    title: "Building Confidence",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_fencing-kids-pass/artifacts/9ml7r36q_20250930_230846000_iOS.MP4",
    thumbnail: "https://customer-assets.emergentagent.com/job_fencing-kids-pass/artifacts/4ljvq5sw_40128070_2377551575588273_3749921978903953408_n.jpg",
    title: "Fencing in Action",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_fencing-kids-pass/artifacts/xrwk744z_20251009_163450000_iOS.MOV",
    thumbnail: "https://customer-assets.emergentagent.com/job_fencing-kids-pass/artifacts/8asf6bdh_27021786_2014567931886641_4564898827470105847_o.jpg",
    title: "Practice Makes Perfect",
  },
];

export default function GallerySection() {
  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <section
      id="gallery"
      className="py-20 bg-[#F4F4F4]"
      data-testid="gallery-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#D4A857]/10 text-[#D4A857] px-4 py-2 rounded text-sm font-bold uppercase tracking-wide mb-4 font-['Montserrat']">
            <Sword size={16} />
            Real Fencing Action!
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0A1A2F] mb-4 font-['Montserrat']">
            See Our <span className="text-[#D4A857]">Fencers</span> in Action
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto font-['Lato']">
            Real photos and videos from our club — your child will be learning <span className="font-bold text-[#0A1A2F]">foil fencing</span> with proper swords and equipment!
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {galleryItems.map((item, index) => (
            <div
              key={index}
              className={`relative group cursor-pointer rounded-lg overflow-hidden bg-white hover:shadow-xl transition-all border-2 border-[#F4F4F4] hover:border-[#D4A857]/30 ${
                index === 0 ? "md:col-span-2 md:row-span-2" : "aspect-square"
              }`}
              onClick={() => setSelectedItem(item)}
              data-testid={`gallery-item-${index}`}
            >
              {item.type === "video" ? (
                <>
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-[#0A1A2F]/40 flex items-center justify-center group-hover:bg-[#0A1A2F]/60 transition-colors">
                    <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                      <Play className="text-[#D4A857] ml-1" size={24} fill="#D4A857" />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <img
                    src={item.src}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A1A2F]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                </>
              )}
              
              {/* Title overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-[#0A1A2F] to-transparent">
                <p className="text-white text-sm font-medium truncate font-['Lato']">{item.title}</p>
              </div>
            </div>
          ))}
        </div>

        {/* What They'll Learn */}
        <div className="mt-12 bg-[#0A1A2F] rounded-lg p-8 text-white">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#D4A857] mb-4 font-['Montserrat']">Real Olympic-Style Sword Fencing with Foils</h3>
              <p className="text-white/90 leading-relaxed mb-4 font-['Lato']">
                Your child will learn <span className="font-bold">foil fencing</span> — a real Olympic sword discipline. 
                They'll use proper fencing swords (foils), learn authentic techniques, and compete using our 
                <span className="font-bold"> full electric scoring system</span>.
              </p>
              <div className="flex flex-wrap gap-3">
                <span className="bg-white/10 px-4 py-2 rounded text-sm font-medium border border-white/20 font-['Lato']">
                  Proper Fencing Swords
                </span>
                <span className="bg-white/10 px-4 py-2 rounded text-sm font-medium border border-white/20 font-['Lato']">
                  Electric Scoring
                </span>
                <span className="bg-white/10 px-4 py-2 rounded text-sm font-medium border border-white/20 font-['Lato']">
                  Olympic Discipline
                </span>
              </div>
            </div>
            <div className="flex justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/2pfnnew9_bigger%20masky.png"
                alt="Masky"
                className="w-36 masky-glow"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedItem && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedItem(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-[#D4A857] transition-colors"
            onClick={() => setSelectedItem(null)}
            data-testid="close-lightbox"
          >
            <X size={32} />
          </button>
          
          <div
            className="max-w-4xl max-h-[80vh] w-full"
            onClick={(e) => e.stopPropagation()}
          >
            {selectedItem.type === "video" ? (
              <video
                src={selectedItem.src}
                controls
                autoPlay
                className="w-full max-h-[80vh] rounded-lg"
              >
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={selectedItem.src}
                alt={selectedItem.title}
                className="w-full max-h-[80vh] object-contain rounded-lg"
              />
            )}
            <p className="text-white text-center mt-4 text-lg font-medium font-['Montserrat']">
              {selectedItem.title}
            </p>
          </div>
        </div>
      )}
    </section>
  );
}
